'use strict';

/* Services */
//angular.module('ireactApp.services', []);
